import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import permissions from './mixins/permissions'
import 'babel-polyfill'

function getUrlVars () {
  const vars = {}
  window.location.href.replace(/[?&]+([^=&]+)=([^&|#]*)/gi, function (m, key, value) {
    vars[key] = value
  })
  return vars
}
const getParams = getUrlVars()
if (getParams.url) {
  store.commit('setBaseUrl', getParams.url)
}

Vue.config.productionTip = false
Vue.mixin(permissions)
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
